import type { QuickPollVariant } from "@/types";

import Content from "./content";

type QuickPollAppProps = {
  projectId?: string;
  quickPollId?: string;
  variant?: QuickPollVariant;
};

const App = ({
  projectId = "",
  quickPollId = "",
  variant = "tool"
}: QuickPollAppProps): JSX.Element => (
  <Content variant={variant} projectId={projectId} quickPollId={quickPollId} />
);

export default App;
